import ICON_X_BOLD from '@/assets/sideBar/x_bold.png';
import useGetCsMessage from '@/hooks/useGetCsMessageAlert';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { updateCs } from '@/store/modules/cs';
import { CS_TAB } from '@/types/cs';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

function GuideModal() {
  const dispatch = useAppDispatch();
  const [isShowDefaultModal, setIsShowDefaultModal] = useState(false);
  const [isShowAlertModal, setIsShowAlertModal] = useState(false);

  const { hasTotalCount, total1on1Count, recentNewChatId } = useGetCsMessage();

  const onOpenCsModal = ({ tab, chatId }: { tab: CS_TAB; chatId?: number }) => {
    if (tab === 'CHAT' && chatId) {
      dispatch(
        updateCs({
          isOpenCsModal: true,
          isOpenChat: true,
          chatId,
          activeTab: tab,
        }),
      );
    } else {
      dispatch(
        updateCs({
          isOpenCsModal: true,
          activeTab: tab,
        }),
      );
    }
  };

  useEffect(() => {
    setIsShowAlertModal(hasTotalCount);
    setIsShowDefaultModal(!hasTotalCount);
  }, [hasTotalCount]);

  if (isShowAlertModal) {
    return (
      <NewAlertModal
        onClick={() =>
          onOpenCsModal(
            total1on1Count > 0
              ? { tab: 'CHAT', chatId: recentNewChatId }
              : { tab: 'RESULT' },
          )
        }
      >
        <Text>새 {total1on1Count > 0 ? '메세지가' : '알림이'} 도착했어요</Text>

        <CloseButton
          onClick={(e) => {
            e.stopPropagation();
            setIsShowAlertModal(false);
          }}
        >
          <img src={ICON_X_BOLD} alt='닫기' width={12} />
        </CloseButton>
      </NewAlertModal>
    );
  }

  if (isShowDefaultModal) {
    return (
      <DefaultModal>
        <TextWrapper>
          <Text>소모품 요청이 필요하신가요?</Text>
          <Text>필요한 운영 소모품을 요청하세요</Text>
          <Text>소모품 요청이 필요하신가요?</Text>
        </TextWrapper>

        <CloseButton
          onClick={(e) => {
            e.stopPropagation();
            setIsShowDefaultModal(false);
          }}
        >
          <img src={ICON_X_BOLD} alt='닫기' width={10} />
        </CloseButton>
      </DefaultModal>
    );
  }

  return null;
}

const DefaultModal = styled.aside`
  position: absolute;
  top: -100%;
  left: 32px;
  width: 300px;
  height: 48px;
  padding: 9px 24px;
  background-color: #fff;
  box-shadow: -2px 2px 12px 0px rgba(0, 49, 144, 0.25);
  backdrop-filter: blur(2px);
  border-radius: 12px 12px 12px 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    background: transparent;
    color: #fff;
    border-top: 8px solid #fff;
    border-bottom: 8px solid #fff;
    width: 100%;
    height: calc(100% - 16px);
    z-index: 1;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  animation: animation 6000ms ease-out 0ms infinite;

  @keyframes animation {
    0% {
      transform: translateY(38%);
    }
    10% {
      transform: translateY(38%);
    }

    45% {
      transform: translateY(0%);
    }
    55% {
      transform: translateY(0%);
    }

    90% {
      transform: translateY(-38%);
    }
    100% {
      transform: translateY(-38%);
    }
  }
`;

const Text = styled.span`
  color: #444;
  font-size: 14px;
  font-weight: 800;
  line-height: 21px;
`;

const CloseButton = styled.button`
  border-radius: 30px;
  background: #f5f6f7;
  z-index: 2;
`;

const NewAlertModal = styled.button`
  position: absolute;
  top: calc(-100% + 12px);
  left: 8px;
  width: 172px;
  height: 36px;
  padding: 6px 6px 6px 12px;
  background-color: #fff;
  box-shadow: -2px 2px 20px 0px rgba(0, 49, 144, 0.8);
  backdrop-filter: blur(2px);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  white-space: nowrap;
`;

export default GuideModal;
